window.adev = window.adev || {};

(function () {
	"use strict";

    
    window.adev.featuredCollection = {
        init(){
            document.querySelectorAll('[data-adev-featured-collection="wrap"]:not(.adev-init)').forEach((el) => {
                el.classList.add('adev-init');
                
                const navItemsEl = el.querySelector('[data-adev-featured-collection="nav-items"]');
                if (navItemsEl) {
                    const currentActive = el.querySelector('[data-adev-featured-collection="nav-item"].adev-fc__tab-item-active');
                    if (currentActive) {
                        navItemsEl.style.setProperty('--active-tab-left', currentActive.offsetLeft + 'px');
                        navItemsEl.style.setProperty('--active-tab-width', currentActive.offsetWidth + 'px');
                    }
                }

                el.querySelectorAll('[data-adev-featured-collection="nav-item"]').forEach((navItem) => {
                    navItem.addEventListener('click', (e) => {
                        e.preventDefault();
                        const id = navItem.getAttribute('data-id');

                        el.querySelectorAll('[data-adev-featured-collection="nav-item"].adev-fc__tab-item-active').forEach((nav) => {
                            nav.classList.remove('adev-fc__tab-item-active');
                        });
                        navItem.classList.add('adev-fc__tab-item-active');


                        if (navItemsEl) {
                            navItemsEl.style.setProperty('--active-tab-left', navItem.offsetLeft + 'px');
                            navItemsEl.style.setProperty('--active-tab-width', navItem.offsetWidth + 'px');

                            const scrollLeft = navItemsEl.scrollLeft;
                            const offsetLeft = navItem.offsetLeft;
                            const offsetWidth = navItem.offsetWidth;
                            const clientWidth = navItemsEl.clientWidth;

                            if (offsetLeft < scrollLeft) {
                                navItemsEl.scrollLeft = offsetLeft;
                            } else if (offsetLeft + offsetWidth > scrollLeft + clientWidth) {
                                navItemsEl.scrollLeft = offsetLeft + offsetWidth - clientWidth;
                            } else {
                                navItemsEl.scrollLeft = scrollLeft;
                            }
                        }

                        const contentTab = el.querySelector(`[data-adev-featured-collection="nav-item-content"][data-id="${id}"]`);
                        if(contentTab){
                            el.querySelectorAll('[data-adev-featured-collection="nav-item-content"].active').forEach((content) => {
                                content.classList.remove('active');
                            });

                            contentTab.classList.add('active');
                        }

                    });
                });

            });

            this.fixHeight();

            window.addEventListener('resize', () => {
                clearTimeout(this.resizeTimeout);
                this.resizeTimeout = setTimeout(() => {
                    this.fixHeight();
                }, 100);
            });
        },
        resizeTimeout: null,
        hasScrollbar(el){
            return el.scrollWidth > el.clientWidth;
        },
        fixHeight(){
            document.querySelectorAll('[data-adev-featured-collection="wrap"]').forEach((el) => {
                const navItemsEl = el.querySelector('[data-adev-featured-collection="nav-items"]');

                if (navItemsEl) {
                    this.hasScrollbar(navItemsEl) ? navItemsEl.classList.add('has-scrollbar') : navItemsEl.classList.remove('has-scrollbar');

                    const currentActive = el.querySelector('[data-adev-featured-collection="nav-item"].adev-fc__tab-item-active');
                    if (currentActive) {
                        navItemsEl.style.setProperty('--active-tab-left', currentActive.offsetLeft + 'px');
                        navItemsEl.style.setProperty('--active-tab-width', currentActive.offsetWidth + 'px');
                    }
                }
            });
        }
    }

    
    if(Shopify.designMode) {
        window.adev_theme_editor.registerSection('featured-collection', {
            load(section) {
                window.adev.featuredCollection.init();
            },
        })
    }

    window.adev.featuredCollection.init();


})();